// routesConfig.ts
import Dashboard from './pages/home/Dashboard';
import ViewUserScreen from './pages/users/ViewUsersScreen';
import UserAddScreen from './pages/users/UserAddScreen';
import InfoPage from './pages/dev/InfoPage';
import Forbidden403 from './pages/errors/Forbidden403';
import NotFound404 from './pages/errors/NotFound404';
import Server500 from './pages/errors/Server500';
import CalendarScreen from './pages/events/CalendarScreen';
import { AddEventScreen } from './pages/events/AddEventScreen';
import { ViewInvitationScreen } from './pages/users/ViewInvitationScreen';
import UserSettingsScreen from './pages/profile/UserSettingsScreen';
import AssociationSettingsScreen from './pages/profile/AssociationSettingsScreen';
import { ViewEventScreen } from './pages/events/ViewEventScreen';
import ReportTypeManageScreen from './pages/reports/ReportTypeManageScreen';
import ReportTypeEditScreen from './pages/reports/ReportTypeEditScreen';
import EventReportCreateScreen from './pages/reports/EventReportCreateScreen';
import ReportsOverviewScreen from './pages/reports/ReportsOverviewScreen';
import ReportEventOverviewScreen from './pages/reports/ReportEventOverviewScreen';
import ReportViewScreen from './pages/reports/ReportViewScreen';
import TeamManageScreen from './pages/teams/TeamManageScreen';
import TeamEditScreen from './pages/teams/TeamEditScreen';
import { TranslationKey } from './i18n/translations';
export type RouteType = {
    path: string,
    element: React.ElementType,
    name: string,
    nameKey?: TranslationKey,
    deny: string[]
    onNav?: boolean
    group?: string,
    groupKey?: TranslationKey,
    subRoutes?: {
        path: string,
        name: string
    }[],
    cat?: "main" | "admin"
}
const routesConfig: RouteType[] = [
    {
        path: '/dashboard',
        element: Dashboard,
        deny: [],
        name: 'Dashboard',
        nameKey: 'route.dashboard',
        cat: "main"
    },
    {
        path: '/dev-info',
        element: InfoPage,
        deny: [],
        name: 'Developer Info',
        nameKey: 'route.devInfo',
        onNav: false,
    },
    {
        path: '/403',
        element: Forbidden403,
        deny: [],
        name: 'Forbidden',
        nameKey: 'route.forbidden',
        onNav: false
    },
    {
        path: '/404',
        element: NotFound404,
        deny: [],
        name: 'Page Not Found',
        nameKey: 'route.notFound',
        onNav: false
    },
    {
        path: '/500',
        element: Server500,
        deny: [],
        name: 'Server Error',
        nameKey: 'route.serverError',
        onNav: false
    },
    {
        path: '/events',
        element: CalendarScreen,
        deny: [],
        name: 'Event Calendar',
        nameKey: 'route.eventCalendar',
        group: 'events',
        groupKey: 'group.events',
    },
    {
        path: '/event/create',
        element: AddEventScreen,
        deny: [],
        name: 'Create Event',
        nameKey: 'route.createEvent',
        group: 'events',
        groupKey: 'group.events',
    },
    {
        path: '/event/view',
        element: ViewEventScreen,
        deny: ["athlete"],
        name: 'View Event',
        nameKey: 'route.viewEvent',
        onNav: false
    },
    {
        path: '/report/create',
        element: EventReportCreateScreen,
        deny: ["athlete", "parent"],
        name: 'Create Report',
        nameKey: 'route.createReport',
        onNav: false
    },
    {
        path: '/reports',
        element: ReportsOverviewScreen,
        deny: [],
        name: 'Reports',
        nameKey: 'route.reports',
        group: 'reports',
        groupKey: 'group.reports',
    },
    {
        path: '/report/event',
        element: ReportEventOverviewScreen,
        deny: [],
        name: 'Event reports',
        nameKey: 'route.eventReports',
        onNav: false
    },
    {
        path: '/report/view',
        element: ReportViewScreen,
        deny: [],
        name: 'Report detail',
        nameKey: 'route.reportDetail',
        onNav: false
    },
    /*{
        path: '/videos',
        element: VideoOverviewScreen,
        deny: [],
        name: 'Video Overview',
        group: 'videos',
    },
    {
        path: '/video/upload',
        element: VideoUploaderScreen,
        deny: ["athlet"],
        name: 'Upload Video',
        group: 'videos',
    },
    {
        path: '/video/view',
        element: VideoViewerScreen,
        deny: [],
        name: 'Video',
        onNav: false
    },*/
    {
        path: '/settings',
        element: UserSettingsScreen,
        deny: [],
        name: 'Settings',
        nameKey: 'route.settings',
        onNav: false
    },
];

const routesConfigAdmin: RouteType[] = [
    {
        path: '/users',
        element: ViewUserScreen,
        deny: ["athlete"],
        name: 'User Overview',
        nameKey: 'route.userOverview',
        group: 'users',
        groupKey: 'group.users',
        cat: "admin"
    },
    {
        path: '/user/invitations',
        element: ViewInvitationScreen,
        deny: ["athlete"],
        name: 'View Invitation',
        nameKey: 'route.viewInvitation',
        group: 'users',
        groupKey: 'group.users',
        cat: "admin"
    },
    {
        path: '/user/add',
        element: UserAddScreen,
        deny: ["athlete"],
        name: 'Add User',
        nameKey: 'route.addUser',
        group: 'users',
        groupKey: 'group.users',
        cat: "admin"
    },
    {
        path: '/reports/types',
        element: ReportTypeManageScreen,
        deny: ["athlete", "parent"],
        name: 'Report Types',
        nameKey: 'route.reportTypes',
        group: 'reports',
        groupKey: 'group.reports',
        cat: "admin"
    },
    {
        path: '/settings/association',
        element: AssociationSettingsScreen,
        deny: ["athlete", "parent"],
        name: 'Association Settings',
        nameKey: 'route.associationSettings',
        group: 'settings',
        groupKey: 'group.settings',
        cat: "admin"
    },
    {
        path: '/report/edit/:reportTypeId',
        element: ReportTypeEditScreen,
        deny: ["athlete", "parent"],
        name: 'Edit Report Type',
        nameKey: 'route.editReportType',
        onNav: false,
        cat: "admin"
    },
    {
        path: '/teams',
        element: TeamManageScreen,
        deny: ["athlete", "parent"],
        name: 'Teams',
        nameKey: 'route.teams',
        group: 'teams',
        groupKey: 'group.teams',
        cat: "admin"
    },
    {
        path: '/team/edit/:teamId',
        element: TeamEditScreen,
        deny: ["athlete", "parent"],
        name: 'Edit Team',
        nameKey: 'route.editTeam',
        onNav: false,
        cat: "admin"
    },
];


export { routesConfig, routesConfigAdmin };
